import { defineFilterConfig, filterFieldAdapters } from "@src/components/business-form";
import type { FinishedGoodsReceiptFilter } from "../../../../../../api/finishedGoodsReceipts";

/** Значения формы фильтра списка ВЗН УП прихода на СГП. */
export interface StockFinishedGoodsReceiptFilterFormValues {
    /** Код склада СГП. */
    receiverCode: number | null;
    /** Код цеха-отправителя. */
    senderCode: number | null;
    /** Код участка-отправителя. */
    senderSectionCode: number | null;
    /** Номер ВЗН УП. */
    num: string;
    /** Коды статусов ВЗН УП. */
    stateCodes: number[];
}

/** Конфигурация фильтра списка ВЗН УП прихода на СГП. */
export const stockFinishedGoodsReceiptFilterFormConfig = defineFilterConfig<
    StockFinishedGoodsReceiptFilterFormValues,
    FinishedGoodsReceiptFilter
>({
    fields: {
        receiverCode: {
            type: "number",
            nullable: true,
            label: "Склад СГП",
            map: filterFieldAdapters.singleCodeArray("ReceiverCodes"),
        },
        senderCode: {
            type: "number",
            nullable: true,
            label: "Цех-отправитель",
            map: filterFieldAdapters.singleCodeArray("SenderCodes"),
        },
        senderSectionCode: {
            type: "number",
            nullable: true,
            label: "Участок-отправитель",
            /**
             * Зависит от цеха-отправителя: без выбранного цеха участок недоступен. \
             * TODO(forms/spp-lib): заменить на `dependsOn` (+ clearOnChange) в shared form engine;
             * сейчас clear — ручной `onChange` в {@link StockFinishedGoodsReceiptFilterForm}.
             */
            disabled: (values) => values.senderCode == null || values.senderCode === 0,
            map: filterFieldAdapters.singleCodeArray("SenderSectionCodes"),
        },
        num: {
            type: "string",
            label: "Номер ВЗН УП",
            map: {
                from: (domain) => domain.Num ?? "",
                to: (value) => {
                    const trimmed = value.trim();
                    return { Num: trimmed === "" ? undefined : trimmed };
                },
            },
        },
        stateCodes: {
            type: "array",
            label: "Статусы ВЗН УП",
            map: filterFieldAdapters.entityCodes("StateCodes"),
        },
    },
});
